import './Timer.css';
import {useTypedSelector} from "../../../hooks/useTypedSelector";
import Helper from "../../../services/Helper";
import {useState} from "react";
import GameService from "../../../api/GameService";

function CpuTimer (){

    const {phase} = useTypedSelector(state => state.game);
    const [secondsPassed, setSecondsPassed] = useState(25);
    let [timer, setTimer] = useState(null);
    const pvpGameTimeOut = 50;

    let activeClass = '';


    if (phase === 'enemy_turn' && timer === null){

        setSecondsPassed(pvpGameTimeOut);
        // @ts-ignore
        timer = setInterval(() => {

            setSecondsPassed(sp => sp - 1);

        }, 1000);
        setTimer(timer);
    }


    if (secondsPassed === 0 && phase === 'enemy_turn' && timer !== null) {
        setSecondsPassed(5);
        GameService.sendWarning();
    }

    if(phase !== 'enemy_turn' && phase !== 'end_turn' && timer !== null){
        clearInterval(timer);
        setTimer(null);
    }

    if (phase === 'enemy_turn'){
        activeClass = ' playerTimerContainerActive';
    }

    const minutes = Helper.addLeadingZero(~~(secondsPassed / 60));
    const seconds = Helper.addLeadingZero(secondsPassed % 60);

    return <div className={'cpuTimerContainer font-oswald-bold ' + activeClass}>
        <span>{minutes}</span>:<span>{seconds}</span>
    </div>
}
export default CpuTimer;
